import { app } from '@df/core/app';
import { UndefinedOption, atomicColor } from '@df/ui/atomic/atomic-options';
import { ICMS_CLIENT_CONFIG, NICmsClientConfig } from '@icms/client/config/icms-client.config';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import range from 'lodash-es/range';
(NICmsContentComponent.backgroundField.options = () => [
    ...UndefinedOption,
    ...app.injector.get<NICmsClientConfig.IConfig>(ICMS_CLIENT_CONFIG).colors
]),
    NICmsContentComponent.styleFields.push(NICmsContentComponent.backgroundField);
NICmsContentComponent.styleFields.push({
    key: 'styles.anchor',
    type: NICmsContentField.EFieldType.text,
    title: 'Anchor ID',
    group: NICmsContentComponent.EFieldGroup.styles,
    description: 'Used for Indexed Text component click scroll.'
});

export const defaultImage = '/cms/media/default.svg';

export const ICMS_CONFIG: NICmsClientConfig.IConfig = {
    modules: {
        campaigns: {
            enabled: true
        },
        markerIo: {
            enabled: true
        }
    },
    sizes: [
        {
            id: 'X',
            label: 'Large Desktop',
            width: 1920
        },
        {
            id: 'L',
            label: 'Desktop',
            width: 1440,
            default: true
        },
        {
            id: 'M',
            label: 'Tablet',
            width: 768,
            height: 1024
        },
        {
            id: 'S',
            label: 'Mobile',
            width: 375,
            height: 667
        }
    ],
    colors: atomicColor as NICmsClientConfig.IColorConfig[],
    spacings: range(-12, 21).map(key => ({ key: `${key * 4}px`, title: `${key} (${key * 4}px)` }))
};
